import { useDisclosure } from "@mantine/hooks";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Drawer,
  Group,
  ScrollArea,
  Select,
  Image,
  Stack,
  Text,
  TextInput,
  Textarea,
  Title,
  createStyles,
  FileButton,
  Loader,
} from "@mantine/core";

import "./style.css";

import { useForm } from "@mantine/form";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { BiPlusCircle } from "react-icons/bi";
import { uploadClientProfile } from "../../../services/patient";
import { decrypt, encrypt } from "../../../utils";
import {
  createInvoicesSetting,
  EditInvoicesSetting,
  getInvoicesSetting,
} from "../../../services/invoicesetting";
import swal from "sweetalert";

const useStyles = createStyles(() => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "var(--app-bg)",
      minWidth: "400px",
      "@media (max-width:400px)": {
        minWidth: "100%",
      },
    },
    ".mantine-Drawer-body": {
      padding: "0px",
    },
  },
  paymentBox: {
    padding: "20px",
    backgroundColor: "var(--app-surface-2)",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    width: "100%",
    // maxWidth: '400px',
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },

  optionbox: {
    // border-radius: 8px;
    // border: 1px solid var(--app-border);
    // background: var(--app-surface);

    backgroundColor: "var(--app-surface) !important",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    padding: "10px",
  },
  uploadButton: {
    width: "200px",
    height: "50px",
    border: "1px solid var(--app-border)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: "var(--app-surface-2)",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      backgroundColor: "var(--app-border)",
    },
  },
  iconText: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "var(--app-text)",
  },
}));

const bgColor = "var(--app-on-primary)";
// border-radius: 8px;
// border: 1px solid var(--app-border);
// background: var(--White, #FFF);

/* Shadow/xs focused 4px gray-100 */
// box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px var(--app-border);

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "300px",
      // padding: "10px 16px",
      marginTop: "6px",
      borderRadius: "8px",
      backgroundColor: bgColor,

      "& input": {
        backgroundColor: "var(--app-surface)",
        border: "1px solid var(--app-border)",
        //   paddingInline: 0,
        // boxShadow:
        //   "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px var(--app-border)",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

function SettingDrawer({ title, opened, close }) {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state?.profile);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [edit,setEdit]=useState(false)
  const [checkedItems, setCheckedItems] = useState({
    // selectAll: false,
    debitCredit: false,
    ach: false,
    cash: false,
    cheque: false,
  });

  const { settingInvoice  } = useSelector(
    (state) => state.settinginvoice
  );


 

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      note: "",
    },
  });


  // console.log('setting',settingInvoice);
  
  // console.log('image',image);

  const openRef = useRef();

  useEffect(() => {
    if (settingInvoice?.settinginvoice) {
      form.setValues({
        name: settingInvoice?.settinginvoice.name || "",
        email: settingInvoice?.settinginvoice.email || "",
        phone: settingInvoice?.settinginvoice.phone || "",
        note: settingInvoice?.settinginvoice.note || ""
      });

      setImage(settingInvoice?.settinginvoice.image)
      setEdit(true)
       setCheckedItems(settingInvoice?.settinginvoice.paymentsOptions)
    }
  }, [settingInvoice?.settinginvoice]);


  const onChangePhoto = async (files) => {

    setLoading(true);
    if (files) {
      const formData = new FormData();
      formData.append("file", files);
      const data = await uploadClientProfile(formData);
      // const data = await getSinglePatients(id);
      setImage(encrypt(data?.imageUrl));
      setLoading(false);
      // Update the image URL in the state
      const encryptedImageUrl = encrypt(data?.imageUrl);
      setImage(encryptedImageUrl); // Set encrypted image in state
      setLoading(false);
    }
  };



  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setCheckedItems({
      //   selectAll: isChecked,
      debitCredit: isChecked,
      ach: isChecked,
      cash: isChecked,
      cheque: isChecked,
    });
  };

  const handleCheckboxChange = (key) => {
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
      //   selectAll: false,
    }));
  };

  const savebtn = async () => {
    const values = form.values;
  
  
    // Create the base payload object
    let payload = {
      ...values,
      image,
      paymentsOptions: checkedItems,
      admin: profile.user.id,
    };
  
  

    if (edit) {

      payload.id = settingInvoice?.settinginvoice?.id; 
      

      let res = await EditInvoicesSetting(payload);
      

      if (res && res.status === 200) {
        getInvoicesSetting();
        swal({
          title: `Invoice setting updated successfully`,
          text: "Invoice setting updated successfully",
          dangerMode: false,
        });
        form?.reset();
        backbtn();
      } else {
        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
    
      let res = await createInvoicesSetting(payload);
      

      if (res && res.status === 200) {
        getInvoicesSetting();
        swal({
          title: `Invoice setting created successfully`,
          text: "Invoice setting created successfully",
          dangerMode: false,
        });
        form?.reset();
        backbtn();
      } else {
        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          dangerMode: true,
        });
      }
    }
  };
  
  const backbtn = () => {
    close();
  };

 

  return (
    <>
      <Drawer
        offset={8}
        radius="md"
        size="35%"
        zIndex={1200}
        title={title}
        opened={opened}
        onClose={close}
        position="right"
        className={classes.drawer}
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      >
        <Box className="maindrawer">
          <Box className="mini-drawer">
            <Text ff="Inter" fz={18} fw={600} color="var(--app-text)">
              Branding and Design
            </Text>

            <Text className="mt24" ff="Inter" fz={14} fw={500} color="var(--app-text)">
              Add Company Logo
            </Text>
            <Group direction="column" align="center" spacing="md">
              {loading ? (
                <Box className={classes.loaderBox}>
                  <Loader
                    color="var(--app-primary)"
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  />
                </Box>
              ) : !image ? (
                <FileButton
                  onChange={(files) => onChangePhoto(files)}
                  openRef={openRef}
                  accept={{
                    "image/*": [],
                  }}
                >
                  {(props) => (
                    <Button className={classes.uploadButton} {...props}>
                      <div className={classes.iconText}>
                        <BiPlusCircle size={20} />
                        <span>Add Logo</span>
                      </div>
                    </Button>
                  )}
                </FileButton>
              ) : (
                <Image
                  src={decrypt(image)}
                  alt="Uploaded Logo"
                  width={150}
                  height={150}
                  fit="contain"
                />
              )}
            </Group>

            <Text className="mt24" ff="Inter" fz={14} fw={500} color="var(--app-text)">
              Company Name
            </Text>

            <Box>
              <CustomTextInput
                id="invoice-Number"
                // label={"Facility Name"}
                required
                size="sm"
                placeholder={"Enter Customer Name"}
                // placeholder={"Enter Medication Name"}
                // {...form.getInputProps("medicationName")}
                withAsterisk
                {...form.getInputProps("name")}
                // disabled={isPreview}
              />

              {/* <Box className={classes.line}></Box> */}
            </Box>

            <Box className="flex">
              <Box>
                <Text
                  className="mt24"
                  ff="Inter"
                  fz={14}
                  fw={500}
                  color="var(--app-text)"
                >
                  Company Phone #
                </Text>
                <CustomTextInput
                  id="invoice-Number"
                  // label={"Facility Name"}
                  required
                  size="sm"
                  placeholder={"Enter Customer Phone"}
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("phone")}
                  // disabled={isPreview}
                />

                {/* <Box className={classes.line}></Box> */}
              </Box>

              <Box>
                <Text
                  className="mt24"
                  ff="Inter"
                  fz={14}
                  fw={500}
                  color="var(--app-text)"
                >
                  Company Email
                </Text>

                <CustomTextInput
                  id="invoice-Number"
                  // label={"Facility Name"}
                  required
                  size="sm"
                  placeholder={"Enter Customer Name"}
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("email")}
                  // disabled={isPreview}
                />

                {/* <Box className={classes.line}></Box> */}
              </Box>
            </Box>

            <Box style={{ marginTop: "24px", marginBottom: "10px" }}>
              <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                Invoice Note
              </Text>
            </Box>

            <Textarea
              //   label="Input label"
              //   description="Input description"
              autosize
              minRows={6}
              placeholder="Enter invoice note"
              {...form.getInputProps("note")}
            />

            <Text className="mt24" ff="Inter" fz={18} fw={600} color="var(--app-text)">
              Payments
            </Text>

            <Card className={classes.paymentBox}>
              <Title order={5} mb={10}>
                Select Payment Option(s)
              </Title>
              {/* <Group direction="column"> */}
              <Stack
                //   h={300}
                bg="var(--mantine-color-body)"
                align="stretch"
                justify="center"
                gap="md"
                className={classes.optionbox}
              >
                <Checkbox
                  label="Select All"
                  checked={checkedItems.selectAll}
                  onChange={handleSelectAll}
                />
                <Checkbox
                  label="Debit/Credit Card"
                  checked={checkedItems.debitCredit}
                  onChange={() => handleCheckboxChange("debitCredit")}
                />
                <Checkbox
                  label="ACH"
                  checked={checkedItems.ach}
                  onChange={() => handleCheckboxChange("ach")}
                />
                <Checkbox
                  label="Cash"
                  checked={checkedItems.cash}
                  onChange={() => handleCheckboxChange("cash")}
                />
                <Checkbox
                  label="Cheque"
                  checked={checkedItems.cheque}
                  onChange={() => handleCheckboxChange("cheque")}
                />
              </Stack>
            </Card>

            <Box
              style={{ marginTop: "36px", marginBottom: "20px" }}
              className="flex"
            >
              <Button
                variant="filled"
                onClick={backbtn}
                c={"var(--app-text)"}
                style={{ width: "40%" }}
                // className={classes.backNextBtn}
                color="gray"
                size="md"
              >
                Cancel
              </Button>

              <Button
                onClick={savebtn}
                variant="filled"
                style={{ width: "40%" }}
                c={"var(--app-on-primary)"}
                radius={"md"}
                size="md"
                sx={{ backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", "&:hover": { backgroundColor: "var(--app-primary)", filter: "brightness(0.95)" } }}
                // className={classes.backNextBtn}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default SettingDrawer;
